/**
 * Attempts to create a valid Date given a timestamp string formatted as: formatted as:
 * YYYYYMMDD_HHMMSS
 *
 * @param   {string} dateTime The timestamp from a log's S3 object key
 * @returns {Date} A JavaScript date, or null if input is invalid
 */
export const parseLogDate = (dateTimeArg: string): Date => {
    const dateTime = dateTimeArg.replace(new RegExp(/_/, 'g'), '') ?? '';
    let logDate = new Date();

    const yearRegex = `(^[0-9]{4})`;
    const monthRegex = `(^[0-9]{4}(0[1-9])|^[0-9]{4}(1[0-2]))`;
    const dayRegex = `(^[0-9]{6}([0-3][0-9])|^[0-9]{6}(3[01]))`;
    const hourRegex = `(^[0-9]{8}([01][0-9])|^[0-9]{8}(2[0-3]))`;
    const minuteRegex = `(^[0-9]{10}([0-5][0-9]))`;
    const secondRegex = `(^[0-9]{12}([0-5][0-9]))`;
    const millisecondRegex = `(^[0-9]{14}([0-9][0-9][0-9]))`;

    const year =
        dateTime
            .match(yearRegex)
            ?.find(result => result && result.length === 4) ?? '';
    const month =
        dateTime
            .match(monthRegex)
            ?.find(result => result && result.length === 2) ?? '';
    const day =
        dateTime
            .match(dayRegex)
            ?.find(result => result && result.length === 2) ?? '';
    const hour =
        dateTime
            .match(hourRegex)
            ?.find(result => result && result.length === 2) ?? '';
    const minute =
        dateTime
            .match(minuteRegex)
            ?.find(result => result && result.length === 2) ?? '';
    const second =
        dateTime
            .match(secondRegex)
            ?.find(result => result && result.length === 2) ?? '';
    const millisecond =
        dateTime
            .match(millisecondRegex)
            ?.find(result => result && result.length === 3) ?? '';

    if (
        year !== '' &&
        month !== '' &&
        day !== '' &&
        hour !== '' &&
        minute !== '' &&
        second !== '' &&
        millisecond === ''
    ) {
        logDate = new Date(
            parseInt(year, 10),
            // In JavaScript's Date() function, month input is 0-indexed
            parseInt(month, 10) - 1,
            parseInt(day, 10),
            parseInt(hour, 10),
            parseInt(minute, 10),
            parseInt(second, 10),
        );
    } else if (
        year !== '' &&
        month !== '' &&
        day !== '' &&
        hour !== '' &&
        minute !== '' &&
        second !== '' &&
        millisecond !== ''
    ) {
        logDate = new Date(
            parseInt(year, 10),
            // In JavaScript's Date() function, month input is 0-indexed
            parseInt(month, 10) - 1,
            parseInt(day, 10),
            parseInt(hour, 10),
            parseInt(minute, 10),
            parseInt(second, 10),
            parseInt(millisecond, 10),
        );
    }

    return logDate;
};
